import {AxiosInstance} from "axios";
import API from "../../utils/api";
import {
    DailyStatement, DailyStatementItem, UploadDailyStatement
} from "../../models/accounting/daily-statements";
import {PaginatedResult} from "../../models/core/paginated.result";
import {PaginatedRequest} from "../../models/core/paginated.request";

export class DailyStatementService {
    api: AxiosInstance = API;

    get(id: number): Promise<DailyStatement> {
        return this.api.get('accounting/daily-statement/' + id)
            .then((x) => x.data);
    }

    getAll(request: PaginatedRequest): Promise<PaginatedResult<DailyStatement>> {
        return this.api.get('accounting/daily-statement', {
                params: request.toParams(),
            })
            .then((x) => x.data);
    }

    getAllItemsForStatement(id: number, request: PaginatedRequest): Promise<PaginatedResult<DailyStatementItem>> {
        return this.api.get('accounting/daily-statement/' + id + '/items', {
            params: request.toParams(),
        })
            .then((x) => x.data);
    }

    uploadStatement(dto: UploadDailyStatement): Promise<DailyStatement> {

        const formData = new FormData();
        formData.append('file', dto.file);

        return this.api
            .post<DailyStatement>('accounting/daily-statement/upload', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(x => x.data);
    }
}

export const dailyStatementService = new DailyStatementService();